import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { UserRole } from '../models';
import { SERVER_BASE_URL } from '@ca/ca-ng-core';
import { D4CActions, Selectors } from '../store';

@Component({
  selector: 'd4c-role-selector',
  imports: [CommonModule],
  template: `
    <section class="role-selector">
      @for (role of roles$ | async; track role.filter) {
        <button
          class="role-selector-option"
          (click)="selectRole(role.filter)"
          [id]="'role-selector-' + role.filter"
          [style.background-image]="
            role.image && role.image.src ? 'url(' + base + role.image.src + ')' : undefined
          ">
          {{ role.name }}
        </button>
      }
    </section>
  `
})
export class RoleSelectorComponent {
  private store = inject(Store);
  protected roles$ = this.store.select(Selectors.selectMenuFilters);
  readonly base = inject(SERVER_BASE_URL);

  selectRole(role: UserRole) {
    this.store.dispatch(D4CActions.SetRole({ role }));
  }
}
